<template>
	<v-app id="inspire" :class="{bg: true, isEmbed: isEmbedded}">
			<router-view />
			<v-footer class="d-flex flex-row justify-center text-center app-footer" app v-if="footerAllowedRoutes" height="40">
				<v-row>
					<v-col cols="12" class="align-center text-center try">
						<a href="https://drive.google.com/file/d/1juI6rq9ZyIbOVmrEA_DoXqBrCjkPo5bp/view?usp=sharing" target="_blank" class="black--text text-decoration-none">Terms of Service</a> |
						<a href="https://site.clap-lab.com/" target="_blank" class="black--text text-decoration-none">ClapLab</a> |
						כל הזכויות שמורות ל CloseApp
					</v-col>
				</v-row>
			</v-footer>
    <GlobalSnackbar />
  </v-app>
</template>

<script>
import GlobalSnackbar from "src/components/GlobalSnackbar";

export default {
	name: "App",
	components: {GlobalSnackbar},
	data(){
		return {
			lang: document.documentElement.lang,
			year: (new Date).getFullYear(),
		};
	},
	computed: {
		footerAllowed() {
			return this.$route.meta.footer;
		},
		footerAllowedRoutes() {
			if(this.$route.name == "share-play-page" || this.$route.name == "login-page")
				return false;

			return true;
		},
		isEmbedded() {
			return this.$route.query.embed !== undefined;
		}
	},

};
</script>
<style lang="scss">
.app-footer {
	background-color:white !important;
	color: #333333;
	font-size: 0.95em;
  max-width: 100%;
  overflow-x: hidden;
}

.gradient {
  background-image: linear-gradient(90deg, #e77c2c, #da2570);
}
.v-application{
  background-image: url("/img/background.png") !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.isEmbed {
	background-image: none !important;
	background-color:transparent !important;
}

/*SweetAlert text directions*/
.ltr{
  direction: ltr;
}

.mobile-message{
  position: absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p{
    color: #ED217C;
    font-size: min(1.5rem, 25px);
  }
}
</style>
